import React from "react";
import { Link, useHistory } from "react-router-dom";
import { Form } from "antd";
import { Tabel, Badge, DropDown, DropDownMenu, Modal } from "../core";
import { reducer, initialState } from "../hooks/modalReducer";
import AddPayment from "../components/AddPayment";
import { Menu } from "antd";
import { getCompanyId } from "../helper/utils/companyId";
const CHANGE_DATE_FORMAT = require("../helper/utils/datFormat");

const InvoiceDetail = ({ data = [], onRefresh }) => {
  const history = useHistory();

  const handleCellClick = (record) => {
    history.push({
      pathname: `/print-invoice/${record.cloth_return_id || record.invoice_id}`,
      state: record,
    });
  };

  const columns = [
    {
      title: "Contract #",
      dataIndex: "contract_no",
      key: "contract#",
      width: 150,
      onCell: (record) => ({ onClick: () => handleCellClick(record) }),
    },
    {
      title: "Invoice #",
      dataIndex: "invoice_no",
      key: "invoiceNumber",
      width: 150,
      onCell: (record) => ({ onClick: () => handleCellClick(record) }),
    },
    {
      title: "Invoice Date",
      dataIndex: "invoice_date",
      key: "invoiceDate",
      render: (text, record) =>
        CHANGE_DATE_FORMAT.changeDateFormat(record.invoice_date),
      width: 150,
      onCell: (record) => ({ onClick: () => handleCellClick(record) }),
    },
    {
      title: "Amount/Rs",
      dataIndex: "total_value_include_sale_tax",
      key: "amount",
      width: 150,
      onCell: (record) => ({ onClick: () => handleCellClick(record) }),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: () => <Badge status="partially" text="open" />,
      width: 150,
      onCell: (record) => ({ onClick: () => handleCellClick(record) }),
    },
    {
      title: "",
      dataIndex: "action",
      width: 150,
      render: (text, record, index) => (
        <DropDown
          overlay={
            <MenuCompo
              index={index}
              record={record}
              onRefresh={onRefresh}
            />
          }
          record={record}
        />
      ),
    },
  ];

  const rows = (data || []).map((item, index) => ({
    ...item,
    key: item.invoice_id || item._id || index,
  }));

  return <Tabel columns={columns} data={rows} rowKey="key" />;
};

const MenuCompo = ({ record, onRefresh }) => {
  const [form] = Form.useForm();
  const [state, dispatch] = React.useReducer(reducer, initialState);
  const companyId = getCompanyId();

  function menuClickHandler({ key }) {
    return key === "delete" || key === "mark_as_paid" || key === "add_payment"
      ? dispatch({
          type: "MODAL_VIEW",
          payload: { flag: true, modal_name: key },
        })
      : null;
  }

  const paymentData = {
    contract_id: record.contract_id,
    contract_type: record.type || "fabric",
    company_id: companyId,
    buyer_id: record.buyer_id,
  };

  return (
    <DropDownMenu onClick={menuClickHandler}>
      <Menu.Item key="mark_as_paid">Mark as Paid</Menu.Item>
      <Menu.Item key="add_payment">Add Payment</Menu.Item>
      <Menu.Item key="delete">Delete</Menu.Item>
      <Menu.Item key="view">
        <Link to={`/print-invoice/${record.invoice_id}`}>View</Link>
      </Menu.Item>

      {state.modal_name === "add_payment" ? (
        <Modal
          closable={true}
          visible={state.visible}
          maxwidth="568px"
          footer={false}
          onCancel={() =>
            dispatch({ type: "MODAL_VIEW", payload: false })
          }
          tittle="Add payment"
        >
          <AddPayment
            form={form}
            data={paymentData}
            onCreate={() => {
              dispatch({ type: "MODAL_VIEW", payload: false });
              if (onRefresh) onRefresh();
            }}
            onCancel={() =>
              dispatch({ type: "MODAL_VIEW", payload: false })
            }
          />
        </Modal>
      ) : null}
    </DropDownMenu>
  );
};

export default InvoiceDetail;
